export const GET_ASSIGNMENT_DETAILS = "GET_ASSIGNMENT_DETAILS";
export const SET_CURRENT_ASSIGNMENT_ID = "SET_CURRENT_ASSIGNMENT_ID";
export const SET_TABLE_PAGE = "SET_TABLE_PAGE";
